export default {
  mainView: {
    name: '深圳市萊康寧醫用科技股份有限公司 -實时監護',
    onlineUser: '線上用戶',
    sysSet: '系統設定',
    refresh: '刷新',
    exitFs: '退出全螢幕',
    fs: '全螢幕',
    confirmRefresh: '您確認要重繪介面？',
    refreshSuccess: '重繪成功',
    tips: '溫馨提示',
    closePage: '關閉本頁面',
    notUser: '暫無監護用戶',
    tips1: '您沒有許可權使用實时監護',
    tips2: '登入已失效，請您關閉本頁面，重新從管理系統中打開',
    tips3: '登入失敗，請您關閉窗口，重新打開。',
  },
  userList: {
    notUser: '暫無線上用戶',
    id: '編號',
    name: '姓名',
    phone: '電話',
    chat: '聊天',
    new: '新',
  },
  contactInfo: {
    contInfo: '聯絡資訊',
    pregTel: '孕婦聯絡電話',
    drTel: '主治醫生電話',
    hospName: '醫院名稱',
    hospTel: '醫院電話',
    close: '關閉',
  },
  chatMessage: {
    placeholder: '請輸入您要發送的消息',
    tips: '您正在和{name}溝通',
  },
  settings: {
    cm: '公分‌',
    cmTips: '螢幕上1公分對應的像素寬度',
    fhrRange: '胎心正常範圍值',
    speed: '紙速‌',
    fhr: '胎心範圍',
    bed: '床位',
    bedTips: '螢幕上可顯示的監護人數',
    alarmSet: '警報設定',
    save: '儲存',
    saveSuccess: '儲存成功',
    fhrAlarm: '胎心報警',
  },
  fetalMonitor: {
    fhr1: '胎心一',
    fhr2: '胎心二',
    uc: '宮縮壓',
    fm: '胎動',
    fetal: '手動/自動',
    fhr1Low: '胎心1偏低',
    fhr1High: '胎心1偏高',
    hr2Low: '胎心2偏低',
    fhr2High: '胎心2偏高',
    dueDate: '預產期',
    weeks: '孕週',
  },
}
